import { render } from "./TopBook.vue?vue&type=template&id=4a27a9b0"
import script from "./TopBook.vue?vue&type=script&lang=js"
export * from "./TopBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__